import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import Link from 'next/link';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function ThankYou({data}) {
    const router = useRouter();

	return (
        <>
            <Head>
                <meta name="keywords" content={data ? data.keywords : ''} />
                <title>{data ? data.title : ''}</title>
                <meta name="description" content={data ? data.description : ''} />
                <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
            </Head>
      	    <div className="error-page">
                <Container fluid="xl">
                    <div id="background-wrap">
                        <div class="bubble x1"></div>
                        <div class="bubble x2"></div>
                        <div class="bubble x3"></div>
                        <div class="bubble x4"></div>
                        <div class="bubble x5"></div>
                        <div class="bubble x6"></div>
                        <div class="bubble x7"></div>
                        <div class="bubble x8"></div>
                        <div class="bubble x9"></div>
                        <div class="bubble x10"></div>
                    </div>
                    <div className="review-page_section bottom-spacing_margin thanks-section text-center nw-contact-page">
                        <h1 className="thank-heading"> Thank you!!!</h1>
                        <h3 className="main-heading">Your message has been submitted successfully.</h3>
                        {/*<p className="description-text"> By sharing your experience, your review helps other toprow in your area research and hire only the best pros. </p>*/}
                        <Link  href="/"><a className="primary-btn"><span>Go To Home</span></a></Link>
                    </div>
                </Container>
			</div>
        </>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/thank-you', { headers: {
            "Accept": "application/json" }
        });

        return { props: { data: response.data.data,  } }

    } catch (err) {
        const data = false;

        return { props: { data } };
    }
}

ThankYou.Layout = PublicLayout;

export default ThankYou
